import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.71875 7.57275H12.3021",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.71875 12.6143H16.8854",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.71875 17.6558H16.8854",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.9714 2.53076H4.05469V22.6974H20.5547V7.1141L15.9714 2.53076Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }